import React from 'react';
import i18n from '../../../i18n/i18n';

import { PublicRoute } from '../../../utils/routes';
import LazyImage from '../../../components/LazyImage';

import arrowIcon from "../../../images/bulkListing/right-arrow-icon.png";

const TopBanner = () => {
  return (
    <div className="w-full bg-[url('./images/bulkListing/bulk-listing-background.png')] bg-[length:45%] bg-right-bottom bg-no-repeat mt-[76px] p-[25px] md:py-[30px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center mt-[0px] mb-[20px] lg:mt-[20px]">
        <div className="text-primary900 text-[12px] text-[#929292] font-medium text-center md:text-[14px]">{i18n.t("bulkListing.topBanner.title")}</div>
        <div className="mt-[15px] text-black text-[15px] font-bold text-center md:text-[22px]">{i18n.t("bulkListing.topBanner.subtitle")}</div>
        <div className="mt-[10px] text-black text-[11px] text-center md:text-[13px]">{i18n.t("bulkListing.topBanner.descriptionA")}</div>
        <div className="text-black text-[11px] text-[#929292] text-center md:text-[13px]">{i18n.t("bulkListing.topBanner.descriptionB")}</div>
        <div className="flex mt-[10px] md:mt-[20px]">
          <a href={PublicRoute.BulkListingEnquiry}>
            <div className="bg-gradient-to-r from-[#D93C61] to-[#E5666B] w-[250px] h-[40px] flex flex-row items-center m-[10px] pl-[15px] pr-[20px] py-[10px] border-[0.5px] border-white rounded-[10px] md:w-[300px] md:py-[5px] md:h-[50px]">
              <div className="mx-[10px] text-[12px] text-white md:text-[14px]">{i18n.t("bulkListing.enquiryBanner.collabEnquiry")}</div>
              <LazyImage className="w-[15px] ml-auto object-contain md:w-[20px]" src={arrowIcon} alt="arrow-icon" />
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default TopBanner;